<mat-card class="cipo-card">
    @if (showDesc) {
        <mat-card-title>{{ desc }}</mat-card-title>
    }
    <mat-card-content>
        <form [formGroup]="settingsForm">
            <div>
                @if (showLabelInput) {
                    <mat-form-field class="cipo-input cipo-input--sm">
                        <input matInput formControlName="label" />
                        @if (labelControl.invalid) {
                            <mat-error>
                                {{ "MODULE_DEF_CARD.PART_DEFINITION.ERROR_LABEL_REQUIRED" | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                }
            </div>
            <div fxLayout fxLayoutAlign="start center">
                @if (showColonSetting) {
                    <mat-checkbox
                        formControlName="showColon"
                        class="cipo-bg--white part-container mat-button-toggle-group-appearance-standard"
                        [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.SHOW_COLON' | translate">
                        {{ "MODULE_DEF_CARD.PART_DEFINITION.SHOW_COLON" | translate }}
                    </mat-checkbox>
                }
                @if (showLabelValueAlignment) {
                    <mat-button-toggle-group formControlName="labelValueAlignment">
                        <mat-button-toggle
                            [value]="1"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VALUE_ALIGNMENT_HORIZONTAL_SPLIT' | translate
                            "
                            [title]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VALUE_ALIGNMENT_HORIZONTAL_SPLIT' | translate
                            ">
                            <mat-icon class="material-icons-outlined" style="transform: rotate(90deg)">
                                sensor_window
                            </mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="2"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VALUE_ALIGNMENT_HORIZONTAL_JOIN' | translate
                            "
                            [title]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VALUE_ALIGNMENT_HORIZONTAL_JOIN' | translate
                            ">
                            <mat-icon>crop_landscape</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="3"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VALUE_ALIGNMENT_VERTICAL' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VALUE_ALIGNMENT_VERTICAL' | translate">
                            <mat-icon>crop_portrait</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                }
                @if (showSizeSetting) {
                    <mat-button-toggle-group formControlName="size">
                        @for (partSize of partSizes; track partSize) {
                            <mat-button-toggle
                                [value]="partSize"
                                [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_SIZE' | translate"
                                [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_SIZE' | translate">
                                <span style="font-weight: 400">{{ partSize }}%</span>
                            </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                }
                @if (showFontColor) {
                    <div
                        fxLayoutAlign="center center"
                        class="cipo-bg--white part-container mat-button-toggle-group-appearance-standard">
                        <input
                            matInput
                            type="color"
                            formControlName="fontColor"
                            [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_COLOR' | translate"
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_COLOR' | translate" />
                    </div>
                }
            </div>
            <div>
                @if (showFontStyle) {
                    <mat-button-toggle-group formControlName="fontStyle" multiple>
                        <mat-button-toggle
                            [value]="1"
                            [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_BOLD_TEXT_STYLE' | translate"
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_BOLD_TEXT_STYLE' | translate">
                            <mat-icon>format_bold</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="2"
                            [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_ITALIC_TEXT_STYLE' | translate"
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_ITALIC_TEXT_STYLE' | translate">
                            <mat-icon>format_italic</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="4"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_UNDERLINED_TEXT_STYLE' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_UNDERLINED_TEXT_STYLE' | translate">
                            <mat-icon>format_underlined</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                }
                @if (showFontSize) {
                    <mat-button-toggle-group formControlName="fontSize">
                        @for (textSize of textSizes; track textSize) {
                            <mat-button-toggle
                                [value]="textSize"
                                [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_TEXT_SIZE' | translate"
                                [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_TEXT_SIZE' | translate">
                                <span style="font-weight: 400" [style.fontSize]="getTextSizeToPercent(textSize)">
                                    T{{ textSize }}
                                </span>
                            </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                }
                @if (showAlignHorizontal) {
                    <mat-button-toggle-group formControlName="alignHorizontal">
                        <mat-button-toggle
                            [value]="1"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_HORIZONTALLY_ALIGN_LEFT' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_HORIZONTALLY_ALIGN_LEFT' | translate">
                            <mat-icon>format_align_left</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="2"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_HORIZONTALLY_ALIGN_CENTER' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_HORIZONTALLY_ALIGN_CENTER' | translate">
                            <mat-icon>format_align_center</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="3"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_HORIZONTALLY_ALIGN_RIGHT' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_HORIZONTALLY_ALIGN_RIGHT' | translate">
                            <mat-icon>format_align_right</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                }
                @if (showAlignVertical) {
                    <mat-button-toggle-group formControlName="alignVertical">
                        <mat-button-toggle
                            [value]="1"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VERTICALLY_ALIGN_BOTTOM' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VERTICALLY_ALIGN_BOTTOM' | translate">
                            <mat-icon>vertical_align_bottom</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="2"
                            [attr.aria-label]="
                                'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VERTICALLY_ALIGN_CENTER' | translate
                            "
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VERTICALLY_ALIGN_CENTER' | translate">
                            <mat-icon>vertical_align_center</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle
                            [value]="3"
                            [attr.aria-label]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VERTICALLY_ALIGN_TOP' | translate"
                            [title]="'MODULE_DEF_CARD.PART_DEFINITION.LABEL_VERTICALLY_ALIGN_TOP' | translate">
                            <mat-icon>vertical_align_top</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                }
            </div>
        </form>
    </mat-card-content>
</mat-card>
